<template>
  <div>
    <el-row :gutter="20">
      <!-- <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" size="mini">添加分类</el-button>
      </el-col> -->
      <el-col :span="5">
        <el-input placeholder="评论内容" v-model="params.content" style="width: 100%" size="mini"><el-button slot="append" icon="el-icon-search" @click="searchData"></el-button></el-input>
      </el-col>
    </el-row>
   <el-table :data="catesList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="comment_id" label="ID" width="100"></el-table-column>
      <el-table-column prop="type" label="评论类型" width="90">
          <template slot-scope="scope">
              <el-tag size="mini" effect="plain" type="success" v-if="scope.row.type=='1'">普通视频</el-tag>
              <el-tag size="mini" effect="plain" v-else>短视频</el-tag>
          </template>
      </el-table-column>
      <el-table-column prop="user_id" label="评论者id" width="150">
        <template slot-scope="scope">
        <el-tag>{{scope.row.user_id}}</el-tag>
      </template>
      </el-table-column>
      <el-table-column prop="username" label="评论者" width="150">
        <template slot-scope="scope">
        <el-tag>{{scope.row.username}}</el-tag>
      </template>
      </el-table-column>
      <el-table-column prop="title" label="视频/文章标题" width="150">
        <template slot-scope="scope">
        {{scope.row.title}}      
      </template>
      </el-table-column>
      <el-table-column prop="is_display" align="center" label="评论审核" width="120" >
          <template slot-scope="scope">
              <el-switch v-model="scope.row.is_display"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchAuth(scope.$index, scope.row)"></el-switch>
          </template>
      </el-table-column>
      <el-table-column prop="content" label="评论内容" width="180"></el-table-column>
      <el-table-column prop="created_at" align="center" label="提交时间" width="120" >
          <template slot-scope="scope">
              <el-tag>{{scope.row.created_at}}</el-tag>
          </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>

    </el-table>
    <div class="content-center content-top-padded">
        <el-pagination
                background
                layout="total, sizes, prev, pager, next"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="params.page"
                :page-sizes="[10,20,50]"
                :total="total_count"
                :page-size="params.pageSize">
        </el-pagination>
    </div>
  </div>
</template><script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getCommentList, updateComment, deleteComment} from '@/api/live'
  export default {
    data () {
      return {
        isEdit: false,
        catesList: [],
        loading: false,
        total_count: 0,
        params: {
          page: 1,
          pageSize: 20,
          content: '',
        },
        form: {
          comment_id: '',
          created_at: '',
          content: '',
          is_display: '0',
        },
        memberTagDialog: false
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      handleSizeChange (pageSize) {
          this.params.page = 1
          this.params.pageSize = pageSize
          this.getList()
      },
      
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {

        this.loading = true
        getCommentList(this.params).then(response => {
          this.catesList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      deleteAction (index, row) {
        
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          deleteCate(row.comment_id).then(response => {
            
            this.catesList.splice(index, 1)
            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      switchAuth(index, row) {
          let params = {
              'cate_name': row.cate_name ,
              'is_display': row.is_display ,
          }
          updateComment(row.comment_id,params).then(res => {
              if (res.data.data) {
                  this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 2 * 1000
                  })
                  this.getDataList()
              }
          })
      },
      
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
        this.memberTagDialog = false
      },
      saveCateData () {
        this.memberTagDialog = false
        if (this.form.comment_id) {
          updateComment(this.form.comment_id, this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// comment.vue?7665082e